import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { Snackbar, Alert } from "@mui/material";
import {
  fetchSessions,
  createSession,
  updateSession,
  updateSessionPayment,
  deleteSession,
  fetchWeeklySchedule,
} from "../redux/sessionSlice";
import { fetchCustomers } from "../redux/customerSlice";
import { fetchChildrenByCustomer } from "../redux/childSlice";
import { fetchCustomerPackages } from "../redux/customerPackageSlice";
import "./css/AdminSessionsPage.css";

// TARİH YARDIMCI FONKSİYONLAR

// State ve hesaplamalar için (YYYY-MM-DD) - Date objesi parse edebilir
const formatDateToInput = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Kullanıcıya göstermek için (DD-MM-YYYY) - Türkçe format
const formatDateForDisplay = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${day}-${month}-${year}`;
};

// Date objesinden HH:MM formatı al
const formatTimeToInput = (date) => {
  const d = new Date(date);
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};

// YYYY-MM-DD ve HH:MM'den Date objesi oluştur
const createDateFromInputs = (dateStr, timeStr) => {
  const [year, month, day] = dateStr.split("-").map(Number);
  const [hours, minutes] = timeStr.split(":").map(Number);
  return new Date(year, month - 1, day, hours, minutes, 0, 0);
};

// Pazartesi hesapla
const getMonday = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const day = d.getDay();

  if (day === 0) {
    d.setDate(d.getDate() - 6);
  } else {
    d.setDate(d.getDate() - (day - 1));
  }

  return d;
};

const Modal = ({ children, isOpen, onClose }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      {children}
    </div>,
    document.body
  );
};

const AdminSessionsPage = () => {
  const dispatch = useDispatch();

  const { items: sessions, weeklySchedule } = useSelector(
    (state) => state.sessions
  );
  const { items: customers } = useSelector((state) => state.customers);
  const { items: children } = useSelector((state) => state.children);
  const { items: customerPackages } = useSelector((state) => state.customerPackages);

  const [viewMode, setViewMode] = useState("table");
  const [currentWeekStart, setCurrentWeekStart] = useState(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [editingSession, setEditingSession] = useState(null);

  const [formData, setFormData] = useState({
    customerId: "",
    childId: "",
    sessionDate: "",
    sessionTime: "08:00",
    sessionType: "",
    duration: 60,
    price: "",
    isPaid: false,
    paymentDate: "",
    paymentMethod: "",
    notes: "",
    status: "scheduled",
    customerPackageId: "",
  });

  const [filters, setFilters] = useState({
    customerId: "",
    isPaid: "",
    status: "",
    startDate: "",
    endDate: "",
  });

  const [confirmDelete, setConfirmDelete] = useState(false);
  const [sessionToDelete, setSessionToDelete] = useState(null);

  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success",
  });

  useEffect(() => {
    dispatch(fetchSessions({}));
    dispatch(fetchCustomers({}));
  }, [dispatch]);

  // Haftalık görünüm için Pazartesi hesapla
  useEffect(() => {
    if (viewMode === "weekly" && !currentWeekStart) {
      const monday = getMonday(new Date());
      setCurrentWeekStart(formatDateToInput(monday));
      console.log("İlk Pazartesi:", formatDateToInput(monday));
    }
  }, [viewMode, currentWeekStart]);

  // Haftalık program verilerini çek
  useEffect(() => {
    if (viewMode === "weekly" && currentWeekStart) {
      console.log("Haftalık veri çekiliyor, weekStart:", currentWeekStart);
      dispatch(fetchWeeklySchedule(currentWeekStart));
    }
  }, [viewMode, currentWeekStart, dispatch]);

  useEffect(() => {
    if (formData.customerId) {
      dispatch(fetchChildrenByCustomer(formData.customerId));
      dispatch(fetchCustomerPackages(formData.customerId));
    }
  }, [formData.customerId, dispatch]);

  useEffect(() => {
    const isModalOpen = openDialog || confirmDelete;
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [openDialog, confirmDelete]);

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
  };

  const handleOpenDialog = (session = null) => {
    if (session) {
      const sessionDate = new Date(session.sessionDate);

      setEditingSession(session);
      setFormData({
        customerId: session.customerId._id,
        childId: session.childId._id,
        sessionDate: formatDateToInput(sessionDate),
        sessionTime: formatTimeToInput(sessionDate),
        sessionType: session.sessionType,
        duration: session.duration,
        price: session.price,
        isPaid: session.isPaid,
        paymentDate: session.paymentDate
          ? formatDateToInput(new Date(session.paymentDate))
          : "",
        paymentMethod: session.paymentMethod || "",
        notes: session.notes || "",
        status: session.status,
        customerPackageId: session.customerPackageId?._id || session.customerPackageId || "",
      });
    } else {
      setEditingSession(null);
      setFormData({
        customerId: "",
        childId: "",
        sessionDate: "",
        sessionTime: "08:00",
        sessionType: "",
        duration: 60,
        price: "",
        isPaid: false,
        paymentDate: "",
        paymentMethod: "",
        notes: "",
        status: "scheduled",
        customerPackageId: "",
      });
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditingSession(null);
  };

  const handleSubmit = async () => {
    try {
      const sessionDateTime = createDateFromInputs(
        formData.sessionDate,
        formData.sessionTime
      );

      console.log("Form Data:", formData);
      console.log("Oluşturulan tarih:", sessionDateTime);

      const submitData = {
        customerId: formData.customerId,
        childId: formData.childId,
        sessionDate: sessionDateTime.toISOString(),
        sessionType: formData.sessionType,
        duration: formData.duration,
        price: formData.customerPackageId ? 0 : formData.price,
        isPaid: formData.isPaid,
        paymentDate: formData.paymentDate || null,
        paymentMethod: formData.paymentMethod || null,
        notes: formData.notes || "",
        status: formData.status,
        customerPackageId: formData.customerPackageId || null,
      };

      if (editingSession) {
        await dispatch(
          updateSession({ id: editingSession._id, data: submitData })
        ).unwrap();
        showToast("Seans güncellendi");
      } else {
        await dispatch(createSession(submitData)).unwrap();
        showToast("Seans oluşturuldu");
      }
      handleCloseDialog();
      dispatch(fetchSessions(filters));

      // Haftalık görünümdeyse yenile
      if (viewMode === "weekly" && currentWeekStart) {
        dispatch(fetchWeeklySchedule(currentWeekStart));
      }
    } catch (error) {
      console.error("Submit hatası:", error);
      showToast(error || "İşlem başarısız", "error");
    }
  };

  const handlePaymentToggle = async (session) => {
    try {
      await dispatch(
        updateSessionPayment({
          id: session._id,
          isPaid: !session.isPaid,
          paymentDate: !session.isPaid ? new Date().toISOString() : null,
          paymentMethod: !session.isPaid ? "cash" : null,
        })
      ).unwrap();
      showToast(session.isPaid ? "Ödeme iptal edildi" : "Ödeme alındı");
      dispatch(fetchSessions(filters));

      if (viewMode === "weekly" && currentWeekStart) {
        dispatch(fetchWeeklySchedule(currentWeekStart));
      }
    } catch (error) {
      showToast("Ödeme durumu güncellenemedi", "error");
    }
  };


  const handleStatusToggle = async (session) => {
    try {
      const newStatus =
        session.status === "scheduled" ? "completed" : "scheduled";
      await dispatch(
        updateSession({
          id: session._id,
          data: { status: newStatus },
        }),
      ).unwrap();
      showToast(
        newStatus === "completed"
          ? "Tamamlandı olarak işaretlendi"
          : "Planlandı olarak işaretlendi",
      );
      dispatch(fetchSessions(filters));

      if (viewMode === "weekly" && currentWeekStart) {
        dispatch(fetchWeeklySchedule(currentWeekStart));
      }
    } catch (error) {
      showToast("Durum güncellenemedi", "error");
    }
  };

  const handleDeleteConfirm = async () => {
    try {
      await dispatch(deleteSession(sessionToDelete)).unwrap();
      showToast("Seans silindi", "info");
      dispatch(fetchSessions(filters));

      if (viewMode === "weekly" && currentWeekStart) {
        dispatch(fetchWeeklySchedule(currentWeekStart));
      }
    } catch {
      showToast("Silme başarısız", "error");
    } finally {
      setConfirmDelete(false);
      setSessionToDelete(null);
    }
  };

  const handleApplyFilters = () => {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, v]) => v !== "")
    );
    dispatch(fetchSessions(cleanFilters));
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "completed":
        return "status-success";
      case "scheduled":
        return "status-primary";
      case "cancelled":
        return "status-error";
      case "no_show":
        return "status-warning";
      default:
        return "status-default";
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "completed":
        return "Tamamlandı";
      case "scheduled":
        return "Planlandı";
      case "cancelled":
        return "İptal";
      case "no_show":
        return "Gelmedi";
      default:
        return status;
    }
  };

  const handlePrevWeek = () => {
    const current = new Date(currentWeekStart);
    current.setDate(current.getDate() - 7);
    const newWeekStart = formatDateToInput(current);
    console.log("Önceki hafta:", newWeekStart);
    setCurrentWeekStart(newWeekStart);
  };

  const handleNextWeek = () => {
    const current = new Date(currentWeekStart);
    current.setDate(current.getDate() + 7);
    const newWeekStart = formatDateToInput(current);
    console.log("Sonraki hafta:", newWeekStart);
    setCurrentWeekStart(newWeekStart);
  };

  const handleDownloadPDF = () => {
    const params = currentWeekStart ? `?weekStart=${currentWeekStart}` : "";
    window.open(
      `https://api.dilanaslan.com/api/pdf/weekly-schedule${params}`,
      "_blank"
    );
  };

  return (
    <div className="admin-sessions-page">
      <div className="page-container">
        <div className="page-header">
          <h1 className="page-title">Seans Yönetimi</h1>
          <div className="header-actions">
            <div className="view-toggle">
              <button
                className={`toggle-btn ${viewMode === "table" ? "active" : ""}`}
                onClick={() => setViewMode("table")}
              >
                📋 Tablo
              </button>
              <button
                className={`toggle-btn ${
                  viewMode === "weekly" ? "active" : ""
                }`}
                onClick={() => setViewMode("weekly")}
              >
                📅 Haftalık Program
              </button>
            </div>
            <button
              className="btn btn-primary"
              onClick={() => handleOpenDialog()}
            >
              <span className="btn-icon">➕</span>
              Yeni Seans
            </button>
          </div>
        </div>

        {/* Tablo Görünümü */}
        {viewMode === "table" && (
          <>
            <div className="filters-section">
              <div className="filter-grid">
                <div className="filter-item">
                  <label htmlFor="filter-customer">Müşteri</label>
                  <select
                    id="filter-customer"
                    value={filters.customerId}
                    onChange={(e) =>
                      setFilters({ ...filters, customerId: e.target.value })
                    }
                    className="filter-select"
                  >
                    <option value="">Tümü</option>
                    {customers.map((customer) => (
                      <option key={customer._id} value={customer._id}>
                        {customer.fullName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="filter-item">
                  <label htmlFor="filter-payment">Ödeme</label>
                  <select
                    id="filter-payment"
                    value={filters.isPaid}
                    onChange={(e) =>
                      setFilters({ ...filters, isPaid: e.target.value })
                    }
                    className="filter-select"
                  >
                    <option value="">Tümü</option>
                    <option value="true">Ödendi</option>
                    <option value="false">Ödenmedi</option>
                  </select>
                </div>

                <div className="filter-item">
                  <label htmlFor="filter-status">Durum</label>
                  <select
                    id="filter-status"
                    value={filters.status}
                    onChange={(e) =>
                      setFilters({ ...filters, status: e.target.value })
                    }
                    className="filter-select"
                  >
                    <option value="">Tümü</option>
                    <option value="scheduled">Planlandı</option>
                    <option value="completed">Tamamlandı</option>
                    <option value="cancelled">İptal</option>
                    <option value="no_show">Gelmedi</option>
                  </select>
                </div>

                <div className="filter-item">
                  <label htmlFor="filter-start">Başlangıç</label>
                  <input
                    id="filter-start"
                    type="date"
                    value={filters.startDate}
                    onChange={(e) =>
                      setFilters({ ...filters, startDate: e.target.value })
                    }
                    className="filter-input"
                  />
                </div>

                <div className="filter-item">
                  <label htmlFor="filter-end">Bitiş</label>
                  <input
                    id="filter-end"
                    type="date"
                    value={filters.endDate}
                    onChange={(e) =>
                      setFilters({ ...filters, endDate: e.target.value })
                    }
                    className="filter-input"
                  />
                </div>

                <div className="filter-item filter-btn-wrapper">
                  <button
                    className="btn btn-outlined filter-btn"
                    onClick={handleApplyFilters}
                  >
                    Filtrele
                  </button>
                </div>
              </div>
            </div>

            <div className="table-container">
              <table className="sessions-table">
                <thead>
                  <tr>
                    <th>Tarih & Saat</th>
                    <th>Müşteri</th>
                    <th>Çocuk</th>
                    <th>Seans Tipi</th>
                    <th>Süre</th>
                    <th>Fiyat</th>
                    <th>Ödeme</th>
                    <th>Durum</th>
                    <th className="actions-cell">İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  {sessions.map((session) => {
                    const sessionDate = new Date(session.sessionDate);
                    return (
                      <tr key={session._id}>
                        <td>
                          <div>{formatDateForDisplay(sessionDate)}</div>
                          <div style={{ fontSize: "0.85em", color: "#666" }}>
                            {formatTimeToInput(sessionDate)}
                          </div>
                        </td>
                        <td>{session.customerId?.fullName}</td>
                        <td>{session.childId?.name}</td>
                        <td>{session.sessionType}</td>
                        <td>{session.duration} dk</td>
                        <td className="price-cell">{session.price} TL</td>
                        <td>
                          <button
                            className={`payment-badge ${
                              session.isPaid ? "payment-paid" : "payment-unpaid"
                            }`}
                            onClick={() => handlePaymentToggle(session)}
                            title="Ödeme durumunu değiştir"
                          >
                            <span className="badge-icon">
                              {session.isPaid ? "✓" : "✕"}
                            </span>
                            {session.isPaid ? "Ödendi" : "Ödenmedi"}
                          </button>
                        </td>
                        <td>
                          <button
                            className={`status-badge clickable ${getStatusColor(session.status)}`}
                            onClick={() => handleStatusToggle(session)}
                            title="Durumu değiştir"
                          >
                            {getStatusText(session.status)}
                          </button>
                        </td>
                        <td className="actions-cell">
                          <button
                            className="icon-btn icon-btn-edit"
                            onClick={() => handleOpenDialog(session)}
                            title="Düzenle"
                          >
                            ✏️
                          </button>
                          <button
                            className="icon-btn icon-btn-delete"
                            onClick={() => {
                              setSessionToDelete(session._id);
                              setConfirmDelete(true);
                            }}
                            title="Sil"
                          >
                            🗑️
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {sessions.length === 0 && (
                <div className="empty-state">
                  <p>Henüz seans yok</p>
                </div>
              )}
            </div>
          </>
        )}

        {/* Haftalık Program Görünümü */}
        {viewMode === "weekly" && (
          <div className="weekly-view-container">
            <div className="weekly-header">
              <button className="btn btn-outlined" onClick={handlePrevWeek}>
                ◀ Önceki Hafta
              </button>

              <div className="week-info">
                {weeklySchedule &&
                  weeklySchedule.days &&
                  weeklySchedule.days.length > 0 && (
                    <h2>
                      {weeklySchedule.days[0].dayName}{" "}
                      {weeklySchedule.days[0].date} -{" "}
                      {weeklySchedule.days[6].dayName}{" "}
                      {weeklySchedule.days[6].date}
                    </h2>
                  )}
              </div>

              <button className="btn btn-outlined" onClick={handleNextWeek}>
                Sonraki Hafta ▶
              </button>
            </div>

            <div className="pdf-download-section">
              <button className="btn btn-success" onClick={handleDownloadPDF}>
                📄 Haftalık Program PDF İndir
              </button>
            </div>

            {weeklySchedule && weeklySchedule.days && (
              <div className="weekly-schedule">
                {weeklySchedule.days.map((day, index) => (
                  <div key={index} className="day-card">
                    <div className="day-header">
                      <h3>{day.dayName}</h3>
                      <span className="day-date">{day.date}</span>
                    </div>
                    <div className="day-sessions">
                      {day.sessions.length === 0 ? (
                        <p className="no-sessions">Ders yok</p>
                      ) : (
                        day.sessions.map((session) => {
                          const sessionDate = new Date(session.sessionDate);
                          return (
                            <div key={session._id} className="session-card">
                              <div className="session-time">
                                {formatTimeToInput(sessionDate)}
                              </div>
                              <div className="session-info">
                                <div className="session-customer">
                                  <strong>
                                    {session.customerId?.fullName}
                                  </strong>
                                </div>
                                <div className="session-child">
                                  Çocuk: {session.childId?.name}
                                </div>
                                <div className="session-type">
                                  {session.sessionType}
                                </div>
                                <div className="session-meta">
                                  <span>{session.duration} dk</span>
                                  <span
                                    className={
                                      session.isPaid
                                        ? "payment-paid"
                                        : "payment-unpaid"
                                    }
                                  >
                                    {session.isPaid ? "✓ Ödendi" : "✕ Ödenmedi"}
                                  </span>
                                  <span
                                    className={`status-badge ${getStatusColor(
                                      session.status
                                    )}`}
                                  >
                                    {getStatusText(session.status)}
                                  </span>
                                </div>
                              </div>
                              <div className="session-actions-mini">
                                <button
                                  className="icon-btn-sm"
                                  onClick={() => handleOpenDialog(session)}
                                  title="Düzenle"
                                >
                                  ✏️
                                </button>
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Dialog Modal */}
      <Modal isOpen={openDialog} onClose={handleCloseDialog}>
        <div
          className="modal-content modal-lg"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header">
            <h2>{editingSession ? "Seans Düzenle" : "Yeni Seans"}</h2>
            <button className="modal-close" onClick={handleCloseDialog}>
              ✕
            </button>
          </div>
          <div className="modal-body">
            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="customer">
                  Müşteri <span className="required">*</span>
                </label>
                <select
                  id="customer"
                  value={formData.customerId}
                  onChange={(e) =>
                    setFormData({ ...formData, customerId: e.target.value })
                  }
                >
                  <option value="">Müşteri Seçin</option>
                  {customers.map((customer) => (
                    <option key={customer._id} value={customer._id}>
                      {customer.fullName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="child">
                  Çocuk <span className="required">*</span>
                </label>
                <select
                  id="child"
                  value={formData.childId}
                  onChange={(e) =>
                    setFormData({ ...formData, childId: e.target.value })
                  }
                  disabled={!formData.customerId}
                >
                  <option value="">Çocuk Seçin</option>
                  {children.map((child) => (
                    <option key={child._id} value={child._id}>
                      {child.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Paket Seçimi */}
              {formData.customerId && customerPackages.filter(cp => cp.status === "active").length > 0 && (
                <div className="form-group form-group-full">
                  <label htmlFor="customerPackageId">
                    Paket (opsiyonel — seçilirse paketten hak düşülür)
                  </label>
                  <select
                    id="customerPackageId"
                    value={formData.customerPackageId}
                    onChange={(e) =>
                      setFormData({ ...formData, customerPackageId: e.target.value })
                    }
                  >
                    <option value="">Paketsiz (normal seans)</option>
                    {customerPackages
                      .filter(cp => cp.status === "active")
                      .map(cp => (
                        <option key={cp._id} value={cp._id}>
                          {cp.packageName} — {cp.remainingSessions} seans kaldı
                        </option>
                      ))}
                  </select>
                </div>
              )}

              <div className="form-group">
                <label htmlFor="sessionDate">
                  Tarih <span className="required">*</span>
                </label>
                <input
                  id="sessionDate"
                  type="date"
                  value={formData.sessionDate}
                  onChange={(e) =>
                    setFormData({ ...formData, sessionDate: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <label htmlFor="sessionTime">
                  Saat <span className="required">*</span>
                </label>
                <select
                  className="w-full p-2 border rounded"
                  value={formData.sessionTime}
                  onChange={(e) =>
                    setFormData({ ...formData, sessionTime: e.target.value })
                  }
                >
                  <option value="">Saat Seçin</option>
                  {Array.from({ length: 27 }, (_, i) => {
                    const hour = 8 + Math.floor(i / 2);
                    const minute = i % 2 === 0 ? "00" : "30";
                    if (hour > 21 || (hour === 21 && minute === "30"))
                      return null;
                    const time = `${String(hour).padStart(2, "0")}:${minute}`;
                    return (
                      <option key={time} value={time}>
                        {time}
                      </option>
                    );
                  }).filter(Boolean)}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="sessionType">
                  Seans Tipi <span className="required">*</span>
                </label>
                <select
                  id="sessionType"
                  value={formData.sessionType}
                  onChange={(e) =>
                    setFormData({ ...formData, sessionType: e.target.value })
                  }
                >
                  <option value="">Seans Tipi Seçin</option>
                  <option value="Masabaşı Dil Gelişimi">
                    Masabaşı Dil Gelişimi
                  </option>
                  <option value="Masabaşı eğitimi (zihin)">
                    Masabaşı Zihin Bilişsel Gelişimi
                  </option>
                  <option value="Masabaşı eğitimi (okuma-yazma)">
                    Masabaşı eğitimi (okuma-yazma)
                  </option>
                  <option value="Dışarı Eğitimi (davranış düzenleme)">
                    Dışarı Eğitimi (davranış düzenleme)
                  </option>
                  <option value="Dışarı eğitimi (uyum yakalama)">
                    Dışarı eğitimi (uyum yakalama)
                  </option>
                  <option value="Dışarı eğitimi (sosyal beceri)">
                    Dışarı eğitimi (sosyal beceri)
                  </option>
                  <option value="Dışarı eğitimi (hiperaktivite azalması)">
                    Dışarı eğitimi (hiperaktivite azalması)
                  </option>
                  <option value="Aile Danışmanlığı">Aile Danışmanlığı</option>
                  <option value="Motor Becerileri">Motor Becerileri</option>
                  <option value="Öz Bakım Becerileri">
                    Öz Bakım Becerileri
                  </option>
                  <option value="DIRFloortime">DIRFloortime</option>
                  <option value="Gelişim Değerlendirme Testi">
                    Gelişim Değerlendirme Testi
                  </option>
                  <option value="Oyun Terapisi">Oyun Terapisi</option>
                  <option value="Dikkat Odaklanma Çalışmaları">
                    Dikkat Odaklanma Çalışmaları
                  </option>
                  <option value="Okul Öncesi Hazırlık ve Akademik Beceriler">
                    Okul Öncesi Hazırlık ve Akademik Beceriler
                  </option>
                  <option value="Özel Öğrenme Güçlüğü">
                    Özel Öğrenme Güçlüğü
                  </option>
                  <option value="Online Danışmanlık">Online Danışmanlık</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="status">Durum</label>
                <select
                  id="status"
                  value={formData.status}
                  onChange={(e) =>
                    setFormData({ ...formData, status: e.target.value })
                  }
                >
                  <option value="scheduled">Planlandı</option>
                  <option value="completed">Tamamlandı</option>
                  <option value="cancelled">İptal</option>
                  <option value="no_show">Gelmedi</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="duration">Süre (dakika)</label>
                <input
                  id="duration"
                  type="number"
                  value={formData.duration}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      duration: parseInt(e.target.value),
                    })
                  }
                />
              </div>

              {!formData.customerPackageId && (
                <div className="form-group">
                  <label htmlFor="price">
                    Fiyat (TL) <span className="required">*</span>
                  </label>
                  <input
                    id="price"
                    type="number"
                    value={formData.price}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        price: parseFloat(e.target.value),
                      })
                    }
                  />
                </div>
              )}

              <div className="form-group">
                <label htmlFor="isPaid">Ödeme Durumu</label>
                <select
                  id="isPaid"
                  value={formData.isPaid}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      isPaid: e.target.value === "true",
                    })
                  }
                >
                  <option value={false}>Ödenmedi</option>
                  <option value={true}>Ödendi</option>
                </select>
              </div>

              {formData.isPaid && (
                <>
                  <div className="form-group">
                    <label htmlFor="paymentDate">Ödeme Tarihi</label>
                    <input
                      id="paymentDate"
                      type="date"
                      value={formData.paymentDate}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          paymentDate: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="paymentMethod">Ödeme Yöntemi</label>
                    <select
                      id="paymentMethod"
                      value={formData.paymentMethod}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          paymentMethod: e.target.value,
                        })
                      }
                    >
                      <option value="">Seçin</option>
                      <option value="cash">Nakit</option>
                      <option value="credit_card">Kredi Kartı</option>
                      <option value="bank_transfer">Havale</option>
                      <option value="other">Diğer</option>
                    </select>
                  </div>
                </>
              )}

              <div className="form-group form-group-full">
                <label htmlFor="notes">Notlar</label>
                <textarea
                  id="notes"
                  rows="3"
                  value={formData.notes}
                  onChange={(e) =>
                    setFormData({ ...formData, notes: e.target.value })
                  }
                  placeholder="Seans hakkında notlar..."
                />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={handleCloseDialog}>
              İptal
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={
                !formData.customerId ||
                !formData.childId ||
                !formData.sessionDate ||
                !formData.sessionType ||
                (!formData.customerPackageId && !formData.price)
              }
            >
              {editingSession ? "Güncelle" : "Oluştur"}
            </button>
          </div>
        </div>
      </Modal>

      {/* Silme Onayı Modal */}
      <Modal isOpen={confirmDelete} onClose={() => setConfirmDelete(false)}>
        <div
          className="modal-content modal-sm"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header">
            <h2>Seansı Sil</h2>
            <button
              className="modal-close"
              onClick={() => setConfirmDelete(false)}
            >
              ✕
            </button>
          </div>
          <div className="modal-body">
            <p>
              Bu seansı silmek istediğinizden emin misiniz? Bu işlem geri
              alınamaz.
            </p>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-secondary"
              onClick={() => setConfirmDelete(false)}
            >
              İptal
            </button>
            <button className="btn btn-danger" onClick={handleDeleteConfirm}>
              Sil
            </button>
          </div>
        </div>
      </Modal>

      {/* Toast */}
      <Snackbar
        open={toast.show}
        autoHideDuration={3000}
        onClose={() => setToast({ ...toast, show: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={toast.type}>{toast.message}</Alert>
      </Snackbar>
    </div>
  );
};

export default AdminSessionsPage;
